/**
 * Is this appointment (as Meet's /orgs/:orgId/patient/:demographicNo/appointments returns it) cancelled?
 * emr-api adds `isCancelled`, worked out with the organization's own cancel status. An answer from an older emr-api has no
 * such field, so the standard OSCAR cancel code "C" is the fallback. Plain CommonJS (no spread / for...of) like the other
 * helpers that the node tests load.
 */
function isCancelledAppointment(appointment) {
  if (!appointment) return false;
  if (appointment.isCancelled === true) return true;
  if (appointment.isCancelled === false) return false;
  return appointment.status === "C";
}

module.exports = { isCancelledAppointment: isCancelledAppointment };
